import Vue from 'vue'
import Router from 'vue-router'
import  home from '../views/home.vue'
import  game from '../views/game.vue'
import  serve from '../views/serve.vue'
import  newslist from '../views/news-list.vue'
import  news from '../views/news.vue'
import  common from '../views/common.vue'
import  tracking from '../views/tracking.vue'
import  tracklist from '../views/tracklist.vue'
import  clogin from '../views/chooselogin.vue'
import  vlogin from '../views/vlogin.vue'
import  rologin from '../views/rologin.vue'
import  mlogin from '../views/mlogin.vue'
import  sun1 from '../components/sun1.vue'
import  sun2 from '../components/sun2.vue'
import  sun3 from '../components/sun3.vue'
import  sun4 from '../components/sun4.vue'
import  sun5 from '../components/sun5.vue'
import  sun6 from '../components/sun6.vue'
import  sun7 from '../components/sun7.vue'
import  sun8 from '../components/sun8.vue'
import  sun9 from '../components/sun9.vue'
import  sun10 from '../components/sun10.vue'
import  sun11 from '../components/sun11.vue'
import  sun12 from '../components/sun12.vue'
import  sun13 from '../components/sun13.vue'
import  sun14 from '../components/sun14.vue'
import  sun15 from '../components/sun15.vue'
import  sun16 from '../components/sun16.vue'
import  sun17 from '../components/sun17.vue'
import  sun18 from '../components/sun18.vue'
import  sun19 from '../components/sun19.vue'
import  sun20 from '../components/sun20.vue'
import  sun21 from '../components/sun21.vue'
import  sun22 from '../components/sun22.vue'
import  sun23 from '../components/sun23.vue'
import  sun24 from '../components/sun24.vue'
import  sun25 from '../components/sun25.vue'
import  sun26 from '../components/sun26.vue'
import  sun27 from '../components/sun27.vue'
import  mu1 from '../components/mu1.vue'
import  mu2 from '../components/mu2.vue'
import  mu3 from '../components/mu3.vue'
import  mu4 from '../components/mu4.vue'
import  mu5 from '../components/mu5.vue'
import  mu6 from '../components/mu6.vue'
import  mu7 from '../components/mu7.vue'
import  mu8 from '../components/mu8.vue'
import  mu9 from '../components/mu9.vue'
import  mu10 from '../components/mu10.vue'
import  mu11 from '../components/mu11.vue'
import  ro1 from '../components/ro1.vue'
import  ro2 from '../components/ro2.vue'
import  ro3 from '../components/ro3.vue'
import  ro4 from '../components/ro4.vue'
import  ro5 from '../components/ro5.vue'
import  ro6 from '../components/ro6.vue'
import  ro7 from '../components/ro7.vue'
import  ro8 from '../components/ro8.vue'
import  ro9 from '../components/ro9.vue'
//import  ro10 from '../components/ro10.vue'
import  ro11 from '../components/ro11.vue'
import  vip from '../components/vip.vue'
import  vip1 from '../components/vip1.vue'
import  vip2 from '../components/vip2.vue'
import  complain from '../components/complain.vue'
import  complain1 from '../components/complain1.vue'
import  login from '../views/login.vue'
import  errview from '../views/404.vue'
import  sun_vip from '../views/sun_vip.vue'
import  mu_vip from '../views/mu_vip.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      component:errview
    },
	  {
	    path: '/login',
	    component:login
	  },
	  {
	    path: '/clogin',
	    component:clogin
	  },
	  {
	    path: '/vlogin',
	    component:vlogin
	  },
	  {
	    path: '/rologin',
	    component:rologin
	  },
	  {
	    path: '/mlogin',
	    component:mlogin
	  },
    {
        path: '/',
        component:home
    },
    {
        path: '/game',
        component: game,
    }
    ,
    {
        path: '/serve',
        component: serve
    }
    ,
	{
        path: '/newslist',
        component: newslist
    }
    ,
    {
      path: '/sun_vip',
      component:sun_vip,
      children:[
        {
            path: 'vip',
            component: vip
        },
        {
            path: 'vip1',
            component: vip1
        },
        {
            path: 'vip2',
            component: vip2
        },
        {
            path: 'sun24',
            component: sun24
        },
        ]
    },
    {
      path: '/mu_vip',
      component:mu_vip,
      children:[
        {
            path: 'vip',
            component: vip
        },
        {
            path: 'mu10',
            component: mu10
        },
        {
            path: 'vip2',
            component: vip2
        },
        ]
    },
    {
        path: '/common',
        component:common,
		children:[
			{
			    path: 'sun1',
			    component: sun1
			},
			{
			    path: 'sun2',
			    component: sun2
			},
			{
			    path: 'sun3',
			    component: sun3
			},
			{
			    path: 'sun4',
			    component: sun4
			},
			{
			    path: 'sun5',
			    component: sun5
			},
			{
			    path: 'sun6',
			    component: sun6
			},
			{
			    path: 'sun7',
			    component: sun7
			},
			{
			    path: 'sun8',
			    component: sun8
			},
			{
			    path: 'sun9',
			    component: sun9
			},
			{
			    path: 'sun10',
			    component: sun10
			},
			{
			    path: 'sun11',
			    component: sun11
			},
			{
			    path: 'sun12',
			    component: sun12
			},
			{
			    path: 'sun13',
			    component: sun13
			},
			{
			    path: 'sun14',
			    component: sun14
			},
			{
			    path: 'sun15',
			    component: sun15
			},
			{
			    path: 'sun16',
			    component: sun16
			},
			{
			    path: 'sun17',
			    component: sun17
			},
			{
			    path: 'sun18',
			    component: sun18
			},
			{
			    path: 'sun19',
			    component: sun19
			},
			{
			    path: 'sun20',
			    component: sun20
			},
			{
			    path: 'sun21',
			    component: sun21
			},
			{
			    path: 'sun22',
			    component: sun22
			},
			{
			    path: 'sun23',
			    component: sun23
			},
			{
			    path: 'sun24',
			    component: sun24
			},
			{
			    path: 'sun25',
			    component: sun25
			},
			{
			    path: 'sun26',
			    component: sun26
			},
			{
			    path: 'sun27',
			    component: sun27
			},
			{
			    path: 'mu1',
			    component: mu1
			},
			{
			    path: 'mu2',
			    component: mu2
			},
			{
			    path: 'mu3',
			    component: mu3
			},
			{
			    path: 'mu4',
			    component: mu4
			},
			{
			    path: 'mu5',
			    component: mu5
			},
			{
			    path: 'mu6',
			    component: mu6
			},
			{
			    path: 'mu7',
			    component: mu7
			},
			{
			    path: 'mu8',
			    component: mu8
			},
			{
			    path: 'mu9',
			    component: mu9
			},
			{
			    path: 'mu10',
			    component: mu10
			},
			{
			    path: 'mu11',
			    component: mu11
			},
			{
			    path: 'vip',
			    component: vip
			},
			{
			    path: 'vip1',
			    component: vip1
			},
			{
			    path: 'vip2',
			    component: vip2
			},
			{
			    path: 'ro1',
			    component: ro1
			},
			{
			    path: 'ro2',
			    component: ro2
			},
			{
			    path: 'ro3',
			    component: ro3
			},
			{
			    path: 'ro4',
			    component: ro4
			},
			{
			    path: 'ro5',
			    component: ro5
			},
			{
			    path: 'ro6',
			    component: ro6
			},
			{
			    path: 'ro7',
			    component: ro7
			},
			{
			    path: 'ro8',
			    component: ro8
			},
			{
			    path: 'ro9',
			    component: ro9
			},
			// {
			//     path: 'ro10',
			//     component: ro10
			// },
			{
			    path: 'ro11',
			    component: ro11
			},
		]
    },
	{
	    path: '/tracking',
	    component:tracking
	},
	{
	    path: '/complain',
	    component:complain
	},
	{
	    path: '/complain1',
	    component:complain1
	},
	{
	    path: '/tracklist',
	    component:tracklist
	},
	{
	    path: '/news',
	    component:news
	},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js